<script lang="ts">
	import HomepageBanner from "../components/HomepageBanner.svelte";
	import Layout from "../components/Layout.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./Homepage.translations.json";
	import type { HomepageProps } from "./HomepageProps.js";
	import BlogSection from "../components/BlogSection.svelte";
	import Link from "../components/Link.svelte";
	import HomepageAboutUs from "../components/HomepageAboutUs.svelte";
	import ContactForm from "../components/Contact/ContactForm.svelte";
	import HomepageSoftware from "../components/HomepageSoftware.svelte";
	import HomepageSolutions from "../components/HomepageSolutions.svelte";
	import CareerSection from "../components/CareerSection.svelte";
	import HomepageProjectApproach from "../components/HomepageProjectApproach.svelte";
	import { newsToCard } from "../components/newsToCard.js";
	import { referenceToCard } from "../components/referenceToCard.js";
	import type { CardItem } from "../components/ArticleCardProps.js";
	import { getTenant } from "../getTenant.js";
	import { blogPathMap } from "../../../core/schema/paths/blogPathMap.js";
	import { caseStudiesPathMap } from "../../../core/schema/paths/caseStudiesPathMap.js";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";

	const translate = getTranslate(translations);
	const tenant = getTenant();

	type $$Props = HomepageProps;
	const { news, references, positions } = $$restProps as $$Props;

	const [newestReference] = references.toSorted((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt));
	const newsDesc = news.toSorted((a, b) => Date.parse(b.publishedAt) - Date.parse(a.publishedAt));
	const homepageCards: CardItem[] = [
		...(newestReference ? [referenceToCard(newestReference)] : []),
		...newsDesc.map(newsToCard),
	].slice(0, 3);
</script>

<Layout transparentMenu>
	<HomepageBanner />
	<div class="container">
		<section>
			<HomepageProjectApproach />
		</section>
	</div>

	{#if homepageCards.length > 0}
		<section class="border-lttertiary !mb-0 border-t">
			<div class="mx-4 mb-6 mt-16 md:mx-12 lg:mb-12 xl:mx-32 xl:mb-16">
				<h2 class="text-ltprimary mb-4 uppercase tracking-[0.02em]">
					{translate("headline")}
				</h2>
				<div class="text-2md m-0 tracking-[0.02em]">
					{translate("subHeadline")}
				</div>
			</div>
			<BlogSection cards={homepageCards} />
			<div class="mx-4 my-8 flex flex-col justify-center gap-4 sm:flex-row md:my-10">
				<Link asButton variant="primary" icon={arrowRight} href="/{caseStudiesPathMap[tenant.locale]}"
					>{translate("linkCaseStudies2")}</Link
				>
				<Link asButton variant="secondary" icon={arrowRight} href="/{blogPathMap[tenant.locale]}"
					>{translate("linkBlog2")}</Link
				>
			</div>
		</section>
	{/if}

	<section>
		<HomepageSolutions />
	</section>

	<div class="container">
		<section class="!mb-24">
			<HomepageSoftware />
		</section>
	</div>

	<section>
		<HomepageAboutUs />
	</section>

	<section>
		<CareerSection {positions} />
	</section>

	<section class="!mb-0">
		<ContactForm />
	</section>
</Layout>
